import { useEffect, useRef, useState } from "react";
import { Camera, X } from "lucide-react";

export function PhotoPicker({ photo, onChange }) {
  const ref = useRef(null);
  const [preview, setPreview] = useState(null);
  useEffect(() => {
    if (!photo) return setPreview(null);
    const url = URL.createObjectURL(photo);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [photo]);

  return (
    <div data-testid="chef-photo-picker">
      <input
        ref={ref}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        capture="environment"
        className="hidden"
        onChange={(e) => { onChange(e.target.files?.[0] || null); e.target.value = ""; }}
        data-testid="chef-photo-input"
      />
      {preview ? (
        <div className="relative">
          <img src={preview} alt="Photo choisie" className="w-full max-h-56 object-cover rounded-xl border-2 border-slate-900" data-testid="chef-photo-preview" />
          <button type="button" onClick={() => onChange(null)} aria-label="Retirer la photo" data-testid="chef-photo-remove-btn" className="absolute top-2 right-2 w-9 h-9 rounded-full bg-slate-900/80 text-white grid place-items-center">
            <X className="w-5 h-5" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => ref.current?.click()}
          data-testid="chef-photo-btn"
          className="w-full h-24 rounded-xl border-2 border-dashed border-slate-400 hover:border-orange-500 hover:text-orange-600 flex flex-col items-center justify-center gap-1 font-bold transition-colors"
        >
          <Camera className="w-7 h-7" /> Prendre une photo du chantier
          <span className="text-xs font-normal text-slate-500">L'IA crée la leçon autour de ce qu'on voit</span>
        </button>
      )}
    </div>
  );
}
